module.exports = __webpack_public_path__ + "img/call-accept.f549ecb7.png";